@import 'styles/mixins';
@import 'styles/variables';

.title {
  @include inter-medium;
  font-size: 21px;
  color: $gray-90;
  margin-bottom: 8px;
}

.content {
  font-size: 13px;
  color: $gray-90;
  margin-bottom: 40px;
  & a {
    color: $navy-50;
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
